module.exports = {
	"id": "AI",
	"name": "Anguilla",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.017403,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.011602,
			"23": null,
			"24": null,
			"25": 0.040607,
			"26": 0.046408,
			"27": null,
			"28": null,
			"29": 0.092816,
			"30": null,
			"31": 0.075413,
			"32": 0.011602,
			"33": 0.023204,
			"34": 0.011602,
			"35": null,
			"36": 0.087015,
			"37": 0.029005,
			"38": 0.156627,
			"39": 0.063811,
			"40": null,
			"41": 0.005801,
			"42": 0.005801,
			"43": 0.087015,
			"44": 0.005801,
			"45": 0.023204,
			"46": null,
			"47": 0.011602,
			"48": null,
			"49": 1.351633,
			"50": 0.005801,
			"51": 0.266846,
			"52": 0.307453,
			"53": 20.82559,
			"54": 4.23473,
			"55": 0.046408,
			"56": 0.011602,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.017403,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": 0.017403,
			"45": 0.011602,
			"46": 0.063811,
			"47": 0.539493,
			"48": 0.916558,
			"49": 5.191895,
			"50": 0.110219,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.029005,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.017403,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.377065,
			"38": null,
			"39": null,
			"40": 0.098617,
			"41": 0.005801,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.005801,
			"5": 0.017403,
			"6": null,
			"7": null,
			"8": 0.394468,
			"9": 0.220438,
			"10": 1.270419,
			"3.1": null,
			"3.2": null,
			"5.1": 0.034806,
			"6.1": 0.029005,
			"7.1": 0.017403,
			"9.1": 1.954937
		},
		"ios_saf": {
			"8": 0,
			"10": 5.68782510908,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.153280305162,
			"8.1-8.4": 0.283178868859,
			"9.0-9.2": 0.135094506245,
			"9.3": 2.06105721066
		},
		"android": {
			"3": 0,
			"4": 0.0787423307494,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00984279134367,
			"4.1": 0.284034835917,
			"4.2-4.3": 0.710087089793,
			"4.4": 1.62827891085,
			"4.4.3-4.4.4": 1.64234004134
		},
		"ie": {
			"6": null,
			"7": 0.011602,
			"8": 0.145025,
			"9": 0.748329,
			"10": 0.127622,
			"11": 5.702383,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00405307258568,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000112585349602
		},
		"edge": {
			"12": 0.121821,
			"13": 1.62428,
			"14": 4.513178
		},
		"ie_mob": {
			"10": 0.0778108169014,
			"11": 0.316801183099
		},
		"bb": {
			"7": 0.1353855,
			"10": null
		},
		"samsung": {
			"0": 6.59086
		},
		"and_uc": {
			"0": 0.029386
		},
		"op_mini": {
			"0": 0.0546063420647
		},
		"and_chr": {
			"0": 26.050061
		},
		"and_ff": {
			"0": 0.012594
		}
	},
	"total": 98.1370295
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AI.json
 ** module id = 459
 ** module chunks = 0
 **/